import { render, staticRenderFns } from "./revision.vue?vue&type=template&id=8935ada6&scoped=true&"
import script from "./revision.vue?vue&type=script&lang=js&"
export * from "./revision.vue?vue&type=script&lang=js&"
import style0 from "./revision.vue?vue&type=style&index=0&id=8935ada6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8935ada6",
  null
  
)

export default component.exports